export default "__VITE_ASSET__b0d82672__"